import clsx from 'clsx'
import { useRouter } from 'next/navigation'
import { useCallback, useState } from 'react'

import RubleIcon from 'assets/svg/ruble.svg'
import SaleIcon from 'assets/svg/sale.svg'

import { useAddCartItemsMutation } from '@/entities/cart/api/cart-api-slice'
import { SpecialPromotionProduct } from '@/entities/cart/api/special-promotion'

import { CatalogItemLocation, ProductType, TAddProductRequest } from '@/shared/types/deprecated-types'
import { TProduct } from '@/shared/types/product-types'
import { Button, Text } from '@/shared/ui'

import { usePromotionWithProduct } from '../../hooks/use-promotion-with-product'
import { PromotionProductsModal } from '../promotion-products-modal/promotion-products-modal'

import cl from './promotion-with-product.module.scss'

type PromotionWithProductProps = {
	className?: string
	product: Pick<TProduct, 'ID' | 'KOD' | 'TITLE' | 'PRICE' | 'SECTION_ID'>
}

export const PromotionWithProduct = (props: PromotionWithProductProps) => {
	const { className, product } = props
	const { ID, KOD, TITLE, PRICE, SECTION_ID } = product
	const productId = Number(ID)
	const router = useRouter()
	const [isModalOpen, setModalOpen] = useState(false)
	const { promotion, isLoading } = usePromotionWithProduct({ productId })
	const [addCartItems] = useAddCartItemsMutation()
	const [loadingProductId, setLoadingProductId] = useState<number>()
	const openModal = useCallback(() => setModalOpen(true), [])
	const closeModal = useCallback(() => setModalOpen(false), [])

	const addPairToCart = async (promotionProduct: SpecialPromotionProduct) => {
		if (!ID || !PRICE?.VALUE) return

		setLoadingProductId(promotionProduct.ID)

		try {
			const products: TAddProductRequest[] = [
				{
					ID,
					KOD,
					TITLE,
					PRICE,
					SECTION_ID,
					TYPE_PRODUCTS: ProductType.Product,
					location: CatalogItemLocation.None
				},
				{
					ID: promotionProduct.ID,
					KOD: promotionProduct.KOD,
					TITLE: promotionProduct.TITLE,
					PRICE: promotionProduct.PRICE,
					TYPE_PRODUCTS: ProductType.Product,
					location: CatalogItemLocation.None
				}
			]

			await addCartItems({ products }).unwrap()
			await router.push('/cart')
		} catch {
			return
		} finally {
			setLoadingProductId(undefined)
		}
	}

	if (!productId || isLoading || !promotion?.items.length || !promotion.products.length) return null
	const PromotionIcon = promotion.discountType === 'absolute' ? RubleIcon : SaleIcon

	return (
		<>
			<div className={clsx(cl.root, className)}>
				<div className={cl.iconWrapper}>
					<div className={cl.icon}>
						<PromotionIcon aria-hidden width={24} height={24} />
					</div>
					<span className={cl.iconLabel}>на 2-ой товар</span>
				</div>
				<div className={cl.content}>
					<Text weight="medium" className={cl.title}>
						Добавьте со скидкой <span className={cl.discountLabel}>до {promotion.discountLabel}</span>
					</Text>
					<Text className={cl.message}>Выгода при покупке комплектом</Text>
					<Button theme="link" className={cl.button} onClick={openModal}>
						Выбрать товар
					</Button>
				</div>
			</div>
			<PromotionProductsModal
				items={promotion.items}
				isOpen={isModalOpen}
				onClose={closeModal}
				onBuy={addPairToCart}
				loadingProductId={loadingProductId}
			/>
		</>
	)
}
